import StandardError from '@/modules/errors/Standard'

class StandardRestError extends StandardError {
  constructor(message = 'Failed to fetch.', status = 500, body = {}) {
    super(message)
    this.status = status
    this.body = body
  }
}

export default StandardRestError
